import { render, staticRenderFns } from "./RoleTokenGeneratorModal.vue?vue&type=template&id=6cb98797&scoped=true"
import script from "./RoleTokenGeneratorModal.vue?vue&type=script&lang=js"
export * from "./RoleTokenGeneratorModal.vue?vue&type=script&lang=js"
import style0 from "./RoleTokenGeneratorModal.vue?vue&type=style&index=0&id=6cb98797&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb98797",
  null
  
)

export default component.exports